import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Calendar, DayRange} from "@hassanmojab/react-modern-calendar-datepicker";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import ClickOutsideDetector from "../../../components/clickOutside/click-outside";
import {
    ThinAbsentIcon,
    ThinAddIcon,
    ThinCaretDownIcon,
    ThinEditIcon,
    ThinPersonSearchIcon,
    ThinTimeIcon
} from "../../../components/icons/material-icons";
import {Link} from "react-router-dom";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {AdminsStaffAttendAddEditModal} from "./attend-add-edit-modal";

interface attendInterface {
    id: number,
    staffId: number,
    name: string,
    createdAt: string,
    isExit: boolean,
    createdBy: number,
}

export const AdminsStaffAttendOverview = () => {
    const [list, setList] = useState<attendInterface[]>([]);
    const [data, setData] = useState({
        loaded: false,
        countAll: 0,
        countInside: 0,
    });
    const [filters, setFilters] = useState({
        shown: '' as '' | 'filters' | 'time'
    });
    const [time, setTime] = useState<DayRange>({from: null, to: null});
    const fetchList = () => {
        setFilters({shown: ''});
        const t = {...time};
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
            const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
            fromString = g;
            toString = g2;
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            const g1 = GregorianToPersian(priorDate).split('-');
            from = {
                year: parseInt(g1[0]),
                month: parseInt(g1[1]),
                day: parseInt(g1[2]),
            };
            const g2 = GregorianToPersian(today).split('-');
            to = {
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            };
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            fromString = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
            toString = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            setTime({
                from: from,
                to: to,
            });
        }
        PostJSON(
            Apis.server + '/core/admins/staff/attend/overview',
            {
                from: fromString,
                to: toString,
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: attendInterface[] | null,
                countAll: number,
                countInside: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setData({
                    loaded: true,
                    countAll: d.countAll,
                    countInside: d.countInside,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "حضورغیاب | همکاران | اتوماسیون";
        fetchList();
    }, []);
    const getPercentPresent = (all: number, inside: number) => {
        if (all < 1)
            return 0; // prevent division by zero
        return ((inside * 100) / all).toFixed(0);
    };
    const [addEdit, setAddEdit] = useState({
        show: false,
        id: 0,
        edit: false,
        createdAt: '2000-01-01 00:00:00',
        name: '',
        isExit: false,
    });
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {url: '/admins/staff/attend', title: 'حضورغیاب'},
            ]}/>
            {
                data.loaded ?
                    <div className={"container"} data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-3 col-md-4">
                                <div className="students--dashboard-cards"
                                     data-color="blue">
                                    <em><ThinPersonSearchIcon/></em>
                                    <div>
                                        <b>{CurrencyFormat(data.countInside)}</b>
                                        <span>افراد حاضر</span>
                                        <strong>
                                            {CurrencyFormat(getPercentPresent(data.countAll, data.countInside)) + " درصد حاضر هستند."}
                                        </strong>
                                        <i><em
                                            style={{width: `${getPercentPresent(data.countAll, data.countInside)}%`}}/></i>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <Link to="/admins/staff/attend/list" className="students--dashboard-cards"
                                      data-color="blue">
                                    <em><ThinAbsentIcon/></em>
                                    <div>
                                        <b>{CurrencyFormat(data.countAll - data.countInside)}</b>
                                        <span>افراد غایب</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>گزارشات حضور</b>
                                <div className="d-flex align-items-center" style={{gap: 5}}>
                                    {/*<button onClick={() => setAddEdit({*/}
                                    {/*    show: true,*/}
                                    {/*    name: '',*/}
                                    {/*    id: 0,*/}
                                    {/*    edit: false,*/}
                                    {/*    createdAt: '2000-01-01 00:00:00',*/}
                                    {/*    isExit: false,*/}
                                    {/*})}>*/}
                                    {/*    <ThinAddIcon/>*/}
                                    {/*    <span>افزودن</span>*/}
                                    {/*</button>*/}
                                    <div className="filter-buttons">
                                        <ClickOutsideDetector
                                            onClickOutside={() => {
                                                setFilters(v => {
                                                    let x = {...v};
                                                    x.shown = '';
                                                    return x;
                                                });
                                            }}
                                            className={"filter-button-c" + (filters.shown === 'time' ? ' active' : '')}>
                                            <button onClick={(e) => {
                                                e.stopPropagation();
                                                setFilters(v => {
                                                    let x = {...v};
                                                    x.shown = x.shown === 'time' ? '' : 'time';
                                                    return x;
                                                });
                                            }}>
                                                <ThinTimeIcon/>
                                                <span>زمان</span>
                                                <ThinCaretDownIcon/>
                                            </button>
                                            {
                                                filters.shown === 'time' ?
                                                    <div>
                                                        <label className="f-roboto">لطفا یک بازه
                                                            زمانی را انتخاب
                                                            کنید:</label>
                                                        <Calendar
                                                            value={time}
                                                            onChange={e => setTime(e)}
                                                            shouldHighlightWeekends
                                                            colorPrimary='#0a53be'
                                                            locale={'fa'}
                                                        />
                                                        <div className="text-end">
                                                            <button
                                                                className="filter-button-cta"
                                                                onClick={() => fetchList()}>
                                                                <span>اعمال تغییرات</span>
                                                            </button>
                                                        </div>
                                                    </div> :
                                                    null
                                            }
                                        </ClickOutsideDetector>
                                    </div>
                                </div>
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>کارمند</th>
                                    <th>عملیات</th>
                                    <th>زمان</th>
                                    <th>ثبت‌کننده</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((d, i) =>
                                        <tr key={"Jc3_xS" + i}>
                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td><Link to={`/admins/staff/view/${d.staffId}`}>{d.name}</Link></td>
                                            <td>{d.isExit ? 'خروج' : 'ورود'}</td>
                                            <td>{StringDigitsConvertToPersian(d.createdAt.split(' ')[1] + " " + GregorianToPersian(d.createdAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                            <td>{staffAttendCreatedByToString(d.createdBy)}</td>
                                            <td>
                                                <button onClick={() => setAddEdit({
                                                    show: true,
                                                    name: d.name,
                                                    createdAt: d.createdAt,
                                                    edit: true,
                                                    id: d.id,
                                                    isExit: d.isExit,
                                                })} className="open-tooltip">
                                                    <i>ویرایش</i>
                                                    <ThinEditIcon/>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AdminsStaffAttendAddEditModal
                active={addEdit.show}
                closeHandler={() => setAddEdit(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                edit={addEdit.edit}
                id={addEdit.id}
                isExit={addEdit.isExit}
                createdAt={addEdit.createdAt}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
                name={addEdit.name}
            />
        </>
    );
};

export const staffAttendCreatedByToString = (createdBy: number) => {
    switch (createdBy) {
        case 1:
            return "دستگاه";
        case 2:
            return "اپراتور";
        case 3:
            return "خروج خودکار";
        default:
            return "نامشخص";
    }
};